export default __webpack_public_path__ + "img/logo-summit.14d27173.svg";